import React from 'react';
import { useIntl } from 'react-intl';
import type { Music24Capabilities } from 'fym-common/src/license/music24Plans';
import { TypedMemo } from '../common/types';
import { planNameMessages } from '../music24/config/music24PlanNames';
import { getPlanCapabilities } from '../music24/config/music24PlanCapabilities';
import type { Music24Plan } from '../music24/config/music24StripePlans';

interface TeamSeatsFullNoteProps {
  current: Music24Capabilities;
  nextPlan: Music24Plan | null;
}

/** Design p4's line under the locked "Send invite": how many seats this plan and the next one have. */
const TeamSeatsFullNoteComponent: React.FC<TeamSeatsFullNoteProps> = ({ current, nextPlan }) => {
  const intl = useIntl();
  const nextSeats = nextPlan === null ? null : getPlanCapabilities(nextPlan).seatsLimit;

  const text =
    nextPlan === null || nextSeats === null || current.seatsLimit === null
      ? intl.formatMessage({
          id: 'app.sml.team.invite.seatsFull.noUpgrade',
          defaultMessage: 'Every seat is in use. Remove a member or cancel an invite to free one.',
        })
      : intl.formatMessage(
          {
            id: 'app.sml.team.invite.seatsFull.upgrade',
            defaultMessage:
              '{plan} has {seats, plural, one {# seat} other {# seats}}. {nextPlan} has {nextSeats, plural, one {# seat} other {# seats}}.',
          },
          {
            plan: intl.formatMessage(planNameMessages[current.plan]),
            seats: current.seatsLimit,
            nextPlan: intl.formatMessage(planNameMessages[nextPlan.tier]),
            nextSeats,
          }
        );

  return <p className="text-muted small mt-2 mb-0">{text}</p>;
};

export const TeamSeatsFullNote = TypedMemo(TeamSeatsFullNoteComponent);
